import { getActionName } from '~sharedComponents/ExternalReference/common/getActionName';
import { addListeners } from '~sharedComponents/ExternalReference/common/addListeners';

import { TBoundComponentProps } from '~sharedComponents/ExternalReference/common/types/types';

export const bindToDomElement = (props: TBoundComponentProps) => {
    const { config, translations, rootNode, onBind, componentName } = props;

    const detail = { config, translations, rootNode };
    const callToBind = new CustomEvent(getActionName.bind(componentName), { detail });

    const onBindListener = (event: CustomEvent) => {
        const { detail: incomingDetail } = event;
        if (incomingDetail === detail) {
            onBind?.(event);
        }
    };

    const bindElement = (_componentName: string) => {
        const boundEventName = getActionName.bound(_componentName);

        dispatchEvent(callToBind);

        return addListeners({ eventName: boundEventName, listener: onBindListener });
    };

    const bindOnReady = (_componentName: string) => () => {
        const callback = () => dispatchEvent(callToBind);
        const eventName = getActionName.ready(_componentName);

        return addListeners({ eventName, listener: callback });
    };

    bindElement(componentName);
    bindOnReady(componentName);
};